import React from "react";

const PackIcon = ({ type }) => {
  if (type === "mental") {
    return (
      <svg viewBox="0 0 160 130" className="h-[150px] w-[160px]" aria-hidden="true">
        <ellipse cx="80" cy="58" rx="58" ry="46" fill="#F7F5F1" />
        <path d="M60 95 L48 110 L73 95 Z" fill="#F7F5F1" />
        <text
          x="80"
          y="52"
          textAnchor="middle"
          fill="#1F1F1F"
          fontSize="18"
          fontWeight="700"
          fontFamily="Montserrat, sans-serif"
        >
          you got
        </text>
        <text
          x="80"
          y="75"
          textAnchor="middle"
          fill="#1F1F1F"
          fontSize="18"
          fontWeight="700"
          fontFamily="Montserrat, sans-serif"
        >
          this!
        </text>
      </svg>
    );
  }

  if (type === "time") {
    return (
      <svg viewBox="0 0 140 140" className="h-[96px] w-[96px]" aria-hidden="true">
        <circle cx="70" cy="70" r="69" fill="#D72810" />
        <circle cx="70" cy="70" r="54" fill="#F7F5F1" />
        <circle cx="70" cy="70" r="5" fill="#2A2A2A" />
        <line x1="70" y1="70" x2="70" y2="44" stroke="#2A2A2A" strokeWidth="4" strokeLinecap="round" />
        <line x1="70" y1="70" x2="50" y2="70" stroke="#2A2A2A" strokeWidth="4" strokeLinecap="round" />
        <line x1="70" y1="35" x2="70" y2="22" stroke="#2A2A2A" strokeWidth="4" strokeLinecap="round" />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 130 110" className="h-[92px] w-[104px]" aria-hidden="true">
      <path d="M20 30 Q65 -6 110 30" fill="none" stroke="#F7F5F1" strokeWidth="14" strokeLinecap="round" />
      <path d="M32 52 Q65 24 98 52" fill="none" stroke="#F7F5F1" strokeWidth="12" strokeLinecap="round" />
      <path d="M44 74 Q65 56 86 74" fill="none" stroke="#F7F5F1" strokeWidth="10" strokeLinecap="round" />
      <circle cx="65" cy="93" r="8" fill="#F7F5F1" />
    </svg>
  );
};

const Starterpack = () => {
  const packs = [
    {
      icon: "mental",
      title: "Siapin Mental",
      description: "Biar bisa jawab dengan santai dan penuh percaya diri!",
    },
    {
      icon: "time",
      title: "Luangkan Waktu",
      description: "Biar nggak terburu-buru, fokus jawab tiap soal",
    },
    {
      icon: "internet",
      title: "Internet Lancar",
      description: "Biar tesnya nggak terhenti karena sinyal lemot!",
    },
  ];

  return (
    <section className="st-surface-cream px-6 py-12 sm:px-8 sm:py-14 lg:px-10 lg:py-16">
      <div className="mx-auto max-w-7xl">
        <h2 className="st-font-display text-center text-5xl leading-[0.98] text-[#111111] sm:text-6xl lg:text-[86px]">
          <span className="font-semibold not-italic">Starter </span>
          <span className="font-normal italic">Pack</span>
        </h2>
        <p className="st-font-body mx-auto mt-3 max-w-[660px] text-center text-lg leading-tight text-[#262626] sm:text-xl lg:text-[34px]">
          <span className="block">3 hal wajib yang harus kamu siapin</span>
          <span className="mt-0 block lg:mt-3">SEBELUM mulai tes :</span>
        </p>

        <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-5 lg:mt-10 lg:gap-6">
          {packs.map((pack) => (
            <div
              key={pack.title}
              className="flex min-h-[290px] flex-col items-center rounded-2xl bg-[#3E3A3E] px-5 pb-6 pt-7 text-center text-white"
            >
              <h3 className="st-font-body text-[30px] font-bold leading-tight lg:text-[38px]">{pack.title}</h3>

              <div className="mt-5 flex h-[108px] items-center justify-center">{<PackIcon type={pack.icon} />}</div>

              <p className="st-font-body mt-5 max-w-[290px] text-lg leading-[1.3] text-[#F2F2F2] lg:text-[32px]">
                {pack.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Starterpack;